module.exports = __webpack_public_path__ + "static/media/level_15-16.b2606a1b.jpg";